module.exports = __webpack_public_path__ + "static/media/PROP.b666439d.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/PROP.jpg
// module id = 1773
// module chunks = 1